import { QuotePageA } from './QuotePageA/QuotePageA';
import { QuotePageMinimal } from './QuotePageMinimal/QuotePageMinimal';
import { QuotePageRadio } from './QuotePageRadio/QuotePageRadio';
import { QuotePageWib } from './QuotePageWib/QuotePageWib';
import { store } from '../../store/store';

export function QuotePage() {
  const featureFlag = store.get().context.gaEventData?.experimentVariant;

  switch (featureFlag) {
    case 'control':
      return <QuotePageA />;
    case 'variant_1_simple':
      return <QuotePageMinimal />;
    case 'variant_2_radio':
      return <QuotePageRadio />;
    case 'variant_3_wib':
      return <QuotePageWib />;
    default:
      return <QuotePageA />;
  }
}
